import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageCarouselComponent } from './image-carousel.component';
import { NgxGalleryModule } from '@kolkov/ngx-gallery';

@NgModule({
  declarations: [ImageCarouselComponent],
  exports: [ImageCarouselComponent],
  imports: [CommonModule, NgxGalleryModule],
})
export class ImageCarouselModule {}
